import { useEffect, useState } from "react";
import Router from "./Router/Router";

function App() {
  return (
    <div className="min-w-[1020px]">
      <Router />
    </div>
  );
}

export default App;
